__turbopack_context__.v({
  "navBar": "NavigationBar-module__on_p9q__navBar",
  "navBarLink": "NavigationBar-module__on_p9q__navBarLink",
  "navBarLinkActive": "NavigationBar-module__on_p9q__navBarLinkActive",
});
